<template>
  <v-layout wrap row justify-space-between align-space-around>
    <v-flex xs12 pb-2 v-if="mandatoryMetadataFields.length > 0">
      <span>Mandatory Fields</span>
    </v-flex>
    <v-flex xs12 v-for="field in mandatoryMetadataFields" :key="field.Key">
      <v-layout row wrap>
        <v-flex xs12 sm3 pl-2 pr-2>
          <v-text-field box label="Field Name" v-model="field.Field" :rules="fieldNameRule" readonly></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2>
          <v-select box label="Field Type" :items="fieldTypeNames" v-model="field.FieldType" :rules="fieldTypeRule" readonly></v-select>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2 v-if="field.Field == 'ExecutionId'">
          <metadata-input-field box v-model="field.FieldValue" :input-type="field.FieldType" @input="emitChange" :ignoreValidate="true">
          </metadata-input-field>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2 v-else>
          <metadata-input-field box v-model="field.FieldValue" :input-type="field.FieldType" @input="emitChange">
          </metadata-input-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 pb-2>
      <span>Optional Fields</span>
    </v-flex>

    <v-flex xs12 v-for="(field, i) in additionalMetadataFields" :key="field.Key">
      <v-layout row wrap v-if="field.IsSchemaField">
        <v-flex xs12 sm3 pl-2 pr-2>
          <v-text-field box label="Field Name" v-model="field.Field" :rules="fieldNameRule" @input="emitChange" readonly>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2>
          <v-select box label="Field Type" :items="fieldTypeNames" v-model="field.FieldType" :rules="fieldTypeRule" @input="emitChange" readonly></v-select>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2>
          <metadata-input-field box v-model="field.FieldValue" :input-type="field.FieldType" @input="emitChange" :ignoreValidate="true">
          </metadata-input-field>
        </v-flex>
        <v-flex xs1>
    
        </v-flex>
      </v-layout>
      <v-layout row wrap v-else>
        <v-flex xs12 sm3 pl-2 pr-2>
          <v-text-field box label="Field Name" v-model="field.Field" :rules="fieldNameRule" @input="emitChange" autofocus>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2>
          <v-select box label="Field Type" :items="fieldTypeNames" v-model="field.FieldType" :rules="fieldTypeRule" @input="emitChange"></v-select>
        </v-flex>
        <v-flex xs12 sm4 pl-2 pr-2>
          <metadata-input-field box v-model="field.FieldValue" :input-type="field.FieldType" @input="emitChange" :ignoreValidate="true">
          </metadata-input-field>
        </v-flex>
        <v-flex xs1>
          <v-btn fab icon small outline color="red" @click="removeField(i)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-btn outline color="success" @click="addField" :disabled="disableAddButton" v-if="!hideAddButton">
      <v-icon left>add</v-icon>
      {{ $t('Button.Add_Metadata_Field') }}
    </v-btn>
  </v-layout>
</template>

<script>
  import MetadataInputField from '@/components/Metadata/MetadataInputField'
  import FormValidationUtil from '@/components/mixins/FormValidationUtil'
  import MetadataUtil from '@/components/mixins/MetadataUtil'
  import ReactivityUtil from '@/components/mixins/ReactivityUtil'

  export default {
    components: {
      MetadataInputField,
    },
    mixins: [FormValidationUtil, MetadataUtil, ReactivityUtil],
    props: {
      value: {
        type: Array,
        required: true,
      },
      schema: {
        type: Object,
        default: () => {
          return {
            Fields: [],
          }
        },
      },
      hideAddButton: {
        type: Boolean,
        default: false,
      },
      disableAddButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        mandatoryMetadataFields: [],
        additionalMetadataFields: [],
        fieldNameRule: [
          v => this.rules.required(v) || 'Metadata Field Name is required',
        ],
        fieldTypeRule: [
          v =>
          this.rules.required(v) || 'Metadata Field Type is required',
          v =>
          this.fieldTypeNames.includes(v) ||
          `${v} is not a valid field type name`,
        ],
        inputValue: [],
      }
    },
    computed: {
      schemaFields() {
        if (!(this.schema && this.schema.Fields)) {
          return []
        }
        return this.schema.Fields
      },
      formFields() {
        let that = this
        let fields = []
        fields = fields.concat(
          that.mandatoryMetadataFields.filter(x => that.isNonNullMetadataField(x) && that.isNonInvalidDateField(x))
        )
        fields = fields.concat(that.additionalMetadataFields)
        return fields.map(f => {
          return {
            Field: f.Field,
            FieldType: f.FieldType,
            FieldValue: f.FieldValue,
          }
        })
      },
      isValidMandatoryMetadataFields() {
        let that = this
        let validMandatoryMetadataFields = this.mandatoryMetadataFields.filter(x => that.isNonNullMetadataField(x) && that.isNonInvalidDateField(x))
        return validMandatoryMetadataFields.length == this.mandatoryMetadataFields.length
      },
      isValidAdditionalMetadataFields() {
        return this.checkAdditionMetadataFields()
      },
    },
    watch: {
      schema(n, o) {
        if(o.Fields){
          this.removeMandatoryFields(o)
        }
        this.setFields()
      },
      value() {
        //this.setFields()
        this.inputValue = [...this.value]
      },
    },
    methods: {
      setFields() {
        let newSchemaFields = []
        // let newMandatoryFields = []
        // let newAdditionalFields = []
        this.setFieldsHelperAddMandatoryFields(
          newSchemaFields,
          this.schemaFields
        )
        this.setFieldsHelperPushExistingFields(
          newSchemaFields,
        )
        this.mandatoryMetadataFields = newSchemaFields.filter(x => x.SystemDefined == true)
        this.additionalMetadataFields = newSchemaFields.filter(x => x.SystemDefined == false)
        this.emitChange()
      },
      setFieldsHelperAddMandatoryFields(allFields, schemaFields) {
        let that = this
        schemaFields.forEach(f => {          
          let blankField = {
            Key: that.randomKey(),
            Field: f.Field,
            FieldType: f.FieldType,
            FieldValue: '',
            SystemDefined: f.SystemDefined,
            IsSchemaField: true,
          }
          allFields.push(blankField)
          // if(f.SystemDefined) {
          //   mandatoryFields.push(blankField)
          // } else {
          //   additionalField.push(blankField)
          // }          
        })
      },
      setFieldsHelperPushExistingFields(allFields) {
        let that = this
        this.inputValue.forEach(f => {
          let targetField = allFields.find(
            x => x.Field == f.Field && x.FieldType == f.FieldType
          )
          if (targetField != null) {
            if (targetField.FieldValue == '') {
              targetField.FieldValue = f.FieldValue
            }
          } else {
            allFields.push({
              Key: that.randomKey(),
              Field: f.Field,
              FieldType: f.FieldType,
              FieldValue: f.FieldValue,
              SystemDefined: false,
              IsSchemaField: false,
            })
          }
        })
      },
      addField() {
        this.additionalMetadataFields.push({
          Key: this.randomKey(),
          Field: '',
          FieldType: 'String',
          FieldValue: '',
          SystemDefined: false,
          IsSchemaField: false,
        })
        this.emitChange()
      },
      removeField(i) {
        this.additionalMetadataFields = this.arrayOmitIndex(
          this.additionalMetadataFields,
          i
        )
        this.emitChange()
      },
      emitChange() {
        this.$emit('validate', { isValidMandatoryMetadataFields: this.isValidMandatoryMetadataFields, isValidAdditionalMetadataFields: this.isValidAdditionalMetadataFields})
        this.$emit('input', this.formFields)
      },
      reset() {
        this.mandatoryMetadataFields = []
        this.additionalMetadataFields = []
        this.emitChange()
      },
      randomKey() {
        return Math.random()
          .toString(36)
          .substring(5)
      },
      removeMandatoryFields(o) {
        let that = this
        o.Fields.forEach((item) => {
          let i = that.inputValue.findIndex((n) => n.Field == item.Field && n.FieldType == item.FieldType)
          if(i != -1) {
            that.inputValue = that.arrayOmitIndex(that.inputValue, i)
          } 
        })
        this.$emit('input', this.inputValue)
      },
      checkAdditionMetadataFields() {
        return this.additionalMetadataFields.every(x => !!x.Field && !!x.FieldType)
      },
    },
    mounted() {
      this.inputValue = [...this.value]
      this.setFields()
    },
  }
</script>